import React, { useCallback, useEffect, useState } from "react";
import {
  IconButton,
  FormControl,
  InputAdornment,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useNavigate } from "react-router-dom";
// import { toastr } from "react-redux-toastr";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";

// Project imports
import "../../../Pages/Login/login.css";
import "../../../Styles/GlobalStyles/GlobalStyles.css";
import { ChangePasswordButton } from "../ChangePasswordButton";
import { changePassword, userLogout, changePasswordReset } from "../../../Actions";

const formValidationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(6, "Password must contain at least 6 characters")
    .max(8, "Password cannot be longer than 8 characters")
    .required("This is a required field"),
    confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Passwords do not match')
    .required("This is a required field"),
});

const ChangePasswordForm = () => {
  const getAuth = (state) => state.usersReducer;
  const navigate = useNavigate();
  const globalDispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: formValidationSchema,
    onSubmit: (values) => {
      const reqBody = {
        Confirm: values.confirmPassword,
        Password: values.newPassword,
      }
      globalDispatch(changePasswordReset())
      globalDispatch(changePassword(reqBody))
    },
  });

  const [values, setValues] = useState({
    confirmPassword: "",
    newPassword: "",
    showPassword: false,
  });

  const { 
    changingPassword,
    changePasswordSuccess,
  } = useSelector(getAuth);
 
  const handleClickShowPassword = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  

  useEffect(() => {
    if (!changingPassword && changePasswordSuccess) {
      globalDispatch(userLogout())
      navigate("/login");
    }
  }, [changingPassword, changePasswordSuccess]);

  return (
    <form
      onSubmit={formik.handleSubmit}
      style={{ width: "100%", textAlign: "center" }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormControl
            className="text-field"
            sx={{ mt: 3, width: "45ch" }}
            variant="standard"
          >
            <TextField
              label="New Password"
              variant="standard"
              name="newPassword"
              inputProps={{ style: { fontSize: 20 } }}
              inputlabelprops={{ style: { fontSize: 20 } }}
              id="standard-adornment-user"
              type={values.showPassword ? "text" : "password"}
              value={formik.values.newPassword}
              onBlur={formik.handleBlur}
              error={
                formik.touched.newPassword &&
                Boolean(formik.errors.newPassword) &&
                formik.values.confirmPassword !== formik.values.newPassword
              }
              helperText={
                formik.touched.newPassword && formik.errors.newPassword
              }
              onChange={formik.handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={(e) => e.preventDefault()}
                    >
                      {values.showPassword ? <LockOpenIcon /> : <LockIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl
            className="text-field"
            sx={{ mt: 0, ml: 2, mr: 2, mb: 2, width: "45ch" }}
            variant="standard"
          >
            <TextField
              label="Confirm Password"
              variant="standard"
              name="confirmPassword"
              inputProps={{ style: { fontSize: 20 } }}
              inputlabelprops={{ style: { fontSize: 20 } }}
              id="standard-adornment-password"
              type={values.showPassword ? "text" : "password"}
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.confirmPassword &&
                Boolean(formik.errors.confirmPassword)
              }
              helperText={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      onMouseUp={(e) => e.preventDefault()}
                    >
                      {values.showPassword ? <LockOpenIcon /> : <LockIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <ChangePasswordButton
              type="submit"
              className="login-button"
              sx={{
                mt: 4,
                mb: 5,
                width: "48ch",
                background: changingPassword ? "#72a289" : "",
              }}
              disableElevation
              size="large"
              variant="contained"
              disabled={changingPassword}
            >
              {changingPassword ? (
                <CircularProgress sx={{ color: "#fff" }} />
              ) : (
                <> Save New Password </>
              )}
            </ChangePasswordButton>
          </FormControl>
        </Grid>
      </Grid>
    </form>
  );
};

export default ChangePasswordForm;
